import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'Master heating, cooling and refrigeration systems from fundamentals to field practice. 6 professional volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-background font-sans text-muted antialiased" data-id="element-0" data-mp="nwc1psim5vw9">
      <MetaPixel data-id="element-1" data-mp="stkn01z26g1q" />
      <main data-id="element-2" data-mp="st2g8bersjfk">
        <Hero data-id="element-3" data-mp="ssssyvl40qdk" />
        <LookInsideCarousel data-id="element-4" data-mp="swgmvvugvest" />
        <ProblemSection data-id="element-5" data-mp="35ynugqx9fzv" />
        <SystemSection data-id="element-6" data-mp="356t1855fman" />
        <ModulesSection data-id="element-7" data-mp="34ndtz6vvc0b" />
        <BonusSection data-id="element-8" data-mp="3uct2xiigokzy" />
        <UrgencySection data-id="element-9" data-mp="3udknlyaisybg" />
        <PricingSection data-id="element-10" data-mp="3ubzw6hji5vht" />
        <GuaranteeSection data-id="element-11" data-mp="3uevq7us8c00z" />
        <FAQ data-id="element-12" data-mp="d4e4fpsbp6v4" />
        <ClosingSection data-id="element-13" data-mp="d4xp3e9cy9cu" />
        <SummaryTable data-id="element-14" data-mp="d3cwvvain2i5" />
        <FinalCta data-id="element-15" data-mp="d2l936n5u92f" />
      </main>
      <Footer data-id="element-16" data-mp="85ujnspgu14c" />
      <PurchaseNotification data-id="element-17" data-mp="85bb32lpgp2z" />
    </div>;
}